import React from 'react';
import { Button } from '@mui/material';
import { UOPX_HELP_DESK_PHONE_NUMBER, phoneNumber10Digit } from '../../modules/admissions/constants';

const DeviceClockInfo = () => (
  <>
    <span>
      The clock on your device doesn&apos;t match the time in your current time zone.
      We&apos;re not able to connect you to your application until your device&apos;s
      clock is updated. Go to your system settings to set your date and time automatically.
      Then make sure your time zone matches your current location.
      If you need help making these changes, contact Tech Support at
      {' '}
    </span>
    <Button
      id="sessionCtaAlert"
      className="smallCtaBtn"
      variant="text"
      href={`tel:+1${phoneNumber10Digit(UOPX_HELP_DESK_PHONE_NUMBER)}`}
      disableRipple
    >
      {UOPX_HELP_DESK_PHONE_NUMBER}
    </Button>
    <span>.</span>
    <br />
    <br />
    <span>After your clock is updated, you can return to this page and refresh your browser</span>
  </>
);

export default DeviceClockInfo;
